import { Alert, Box, Dialog, DialogTitle } from '@mui/material'
import { useOrderContext } from '../contexts/OrderContextProvider'
import { EditPaymentForm } from './OrderTimeline/EditPaymentForm'

export default function EditPaymentDialog() {
  const { rfq, closeDialogs, dialogOpen } = useOrderContext()
  return (
    <Dialog onClose={closeDialogs} open={dialogOpen === 'editPayment'}>
      <DialogTitle>Edit Payment</DialogTitle>
      {rfq && (
        <Box p={2} minWidth="20em">
          {rfq.quote?.purchaseOrder?.id ? <EditPaymentForm /> : <Alert severity="error">No purchase order found</Alert>}
        </Box>
      )}
    </Dialog>
  )
}
